import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiPackage } from 'react-icons/fi';
import PortalHeader from '../../components/Portal/PortalHeader';
import { usePortalOrders } from '../../hooks/portal/usePortal';
import './EstadoCuenta.scss';

const EstadoCuenta = () => {
  const navigate = useNavigate();
  const { orders, loading } = usePortalOrders();

  // Extraer todos los productos de las órdenes
  const purchasedProducts = useMemo(() => {
    if (!orders || orders.length === 0) return [];

    const products = [];
    orders.forEach(order => {
      if (order.items && Array.isArray(order.items)) {
        order.items.forEach(item => {
          products.push({
            ...item,
            order_number: order.order_number,
            order_date: order.order_date,
            order_status: order.status
          });
        });
      }
    });

    return products;
  }, [orders]);

  if (loading) {
    return (
      <div className="portal-page">
        <PortalHeader />
        <div className="portal-page__loading">Cargando...</div>
      </div>
    );
  }

  return (
    <div className="portal-page estado-cuenta">
      <PortalHeader />

      <div className="portal-page__container">
        <button
          onClick={() => navigate('/portal')}
          className="back-button"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            background: 'transparent',
            border: 'none',
            color: '#7b2c7f',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            padding: '0.5rem 0',
            marginBottom: '1rem',
            transition: 'color 0.2s ease'
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#5d1f5f'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#7b2c7f'}
        >
          <FiArrowLeft size={20} /> Volver al Portal
        </button>
        <h1 className="portal-page__title">Historial de Productos</h1>

        <div className="estado-cuenta__products">
          <div className="products-info">
            <FiPackage size={24} />
            <span>Total de productos comprados: <strong>{purchasedProducts.length}</strong></span>
          </div>

          {purchasedProducts && purchasedProducts.length > 0 ? (
            <div className="products-table">
              <div className="products-table__header">
                <span>Producto</span>
                <span>Cantidad</span>
                <span>Precio Unit.</span>
                <span>Total</span>
                <span>Orden</span>
                <span>Fecha</span>
              </div>
              {purchasedProducts.map((product, index) => (
                <div key={index} className="products-table__row">
                  <span className="product-name">{product.product_name || 'Sin nombre'}</span>
                  <span className="quantity">{product.quantity}</span>
                  <span className="unit-price">${product.unit_price?.toFixed(2)}</span>
                  <span className="total">${product.total?.toFixed(2)}</span>
                  <span className="order-number">{product.order_number}</span>
                  <span className="order-date">
                    {product.order_date ? new Date(product.order_date).toLocaleDateString() : '-'}
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <FiPackage size={48} />
              <p>No has comprado productos aún</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EstadoCuenta;
